import AppConfig from './interfaces/app-config.interface';

export const config: AppConfig = {
    connectionBeUrl: process.env.REACT_APP_CONNECTION_DATA_URL || 'https://fk4dh2aswi.execute-api.ca-central-1.amazonaws.com/dev'
};
